import { onChangeType } from '../components/Calendar/SmlsCalendar';

export type RecentSearchesType = {
  destination: string;
  date?: onChangeType;
  url: string;
};

const RECENT_SEARCHES = 'recent-searches';
const HOTEL_INDEX = 'hotel-index';

export const setRecentSearch = (value: RecentSearchesType) => {
  const recentSearches = localStorage.getItem(RECENT_SEARCHES);
  if (!recentSearches) {
    return localStorage.setItem(RECENT_SEARCHES, JSON.stringify([value]));
  }
  const parsedRecentSearches = JSON.parse(recentSearches);
  if (parsedRecentSearches.length === 3) {
    parsedRecentSearches.pop();
  }
  parsedRecentSearches.unshift(value);
  return localStorage.setItem(RECENT_SEARCHES, JSON.stringify(parsedRecentSearches));
};

export const getRecentSearch = (): RecentSearchesType[] => {
  const recentSearches = localStorage.getItem(RECENT_SEARCHES);
  if (recentSearches) {
    return JSON.parse(recentSearches);
  }
  return [];
};

export const setHotelIndexInStorage = (index: number) => {
  localStorage.setItem(HOTEL_INDEX, JSON.stringify(index));
};

export const getHotelIndexInStorage = () => {
  const index = localStorage.getItem(HOTEL_INDEX);
  return index;
};
